import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

// Redux
import { connect } from 'react-redux';

// components - imported
import { Avatar } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';
import Verification_Badge from '../common/Verification_Badge';

// Icons - imported

// DraftJS
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import getPlainText from '../../utils/reusable_functions/getPlainText';

const ModalPost = ({ post, auth }) => {

    // Window Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // --- Convert DraftJS text to HTML text

    // Tracks whether the text has been converted
    const [gotText, setGotText] = useState(false);
    // Stores the converted text
    const [textState, setTextState] = useState(null);
    const [rawTextState, setRawTextState] = useState(null);

    // -- Text Truncation Functions ---
        
    // is text expanded?
    const [isExpanded, setIsExpanded] = useState(true);
    const CHARACTER_LIMIT = 200;
    const [shouldTruncate, setShouldTruncate] = useState(false);
    
        // -- END: Text Truncation Functions ---

    useEffect(() => {

        // Add an event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up the event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update the window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Converts the DraftJS text to HTML and sets the converted text
    useEffect(() => {
        if (post && !gotText) {
            let unRawState;
            let unRawDescription;

            if(post.text) {
                try {
                    // Convert stringified DraftJS JSON to a raw JS object
                    const rawBlocksData = JSON.parse(post.text);

                    // Extract just the array of text blocks
                    if (rawBlocksData && Array.isArray(rawBlocksData.blocks)) {
                        unRawState = EditorState.createWithContent(
                            convertFromRaw(rawBlocksData)
                        );

                        unRawDescription = draftToHtml(convertToRaw(unRawState.getCurrentContent()));
                    } else {
                        unRawDescription = post.text;
                    }

                    // -- Text Truncation Functions ---

                    // Check if truncation is needed
                    const plainText = getPlainText(unRawDescription);
                    const shouldTruncate_temp = plainText.length > CHARACTER_LIMIT;
                    const truncated_text = plainText.substring(0, CHARACTER_LIMIT) + '...';
                    setShouldTruncate(shouldTruncate_temp);

                    // -- END: Text Truncation Functions ---

                    setRawTextState(unRawDescription);

                    setTextState(truncated_text);
                } catch (error) {
                    const text_final = post.text;
                    
                    setRawTextState(text_final);
                    setTextState(text_final);
                }
            }
            
            // Marks that the text conversion has been performed
            setGotText(true);
        }
    }, [post, gotText]);

    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    
    return (
        // Render the modal post component 
        <div className="modalPost">

            {/* Avatar - left side 3;7 */}
            <div onClick={() => window.location = `/user/${post.user._id}`} className="modalPost__avatar">

                {post.user && post.user.img ? (
                    <Avatar src={post.user.img} />
                ) : (
                    <DefaultAvatar name={post.user && `${post.user.first_name} ${post.user.last_name}`} />
                )}
            </div>

            {/* Modal Post Main Body - right side 3:7 */}
            <div className="modalPost__body">

                {/* Modal Post Header */}
                <div className="modalPost__header">
                    <div className="modalPost__headerText">
                        <h3>

                            {/* Modal Post Author name */}
                            <span>
                                <Link to={`/user/${post.user._id}`}>
                                    <span>{post.username ? post.username : null} {' '}</span>
                                    <Verification_Badge user={post.user} /> <span>{/*TODO: GET RID OF THIS SPAN*/}</span> 
                                </Link>
                            </span>

                            {/* Post Timestamp */}
                            <span className="modalPost__headerSpecial">
                                {formatDistanceToNow(post.date)} ago
                            </span>
                        </h3>
                    </div>

                    {/* Modal Post Text */}
                    <div className="modalPost__headerDescription">

                        {textState !== null && (
                            <Fragment>
                                {!isExpanded && shouldTruncate 
                                    ? <div dangerouslySetInnerHTML={{__html: textState}} /> 
                                    : <div dangerouslySetInnerHTML={{__html: rawTextState}} />}

                                {shouldTruncate && (
                                    <span 
                                        // onClick={() => setIsExpanded(!isExpanded)}
                                        className='post_see_more_btn'
                                    >
                                        {isExpanded ? 'See less' : 'See more'}
                                    </span>
                                )}
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

ModalPost.propTypes = {

}

const mapStateToProps = state => ({

});

// Connect the ModalPost component to the Redux store and export it
export default connect(mapStateToProps, null)(ModalPost);
